<script lang="ts">
  import { VIEW_NOW } from '$lib/constants/text';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { EventNames, EventSectionName } from '$lib/types/analytics';
  import { cva, type VariantProps } from 'class-variance-authority';
  import { quintOut } from 'svelte/easing';
  import type { HTMLAttributes } from 'svelte/elements';
  import { fade } from 'svelte/transition';

  const toast = cva('toast', {
    variants: {
      toastVarient: {
        success: 'success',
        error: 'error',
        warning: 'warning',
        info: 'info',
        usElection: 'us-election'
      },
      size: {
        small: 'small',
        medium: 'medium',
        large: 'large'
      }
    }
  });

  interface $$Props extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof toast> {
    toastHeading: string;
    isToastVisible: boolean;
    redirectUrl: string;
  }

  export let toastVarient: $$Props['toastVarient'] = 'info';
  export let size: $$Props['size'] = 'medium';
  export let toastHeading: $$Props['toastHeading'];
  export let isToastVisible: $$Props['isToastVisible'] = false;
  export let redirectUrl: $$Props['redirectUrl'];

  const onViewNowClick = () => {
    sendAnalyticsEvent(EventNames.CLICK_CARD, {
      section_name: EventSectionName.BOOKMARK_TOAST,
      description: 'View_now'
    });
  };
</script>

{#if isToastVisible}
  <div class="container">
    <div
      transition:fade={{ duration: 500, delay: 500, easing: quintOut }}
      {...$$props}
      class={`toast-container ${toast({ toastVarient, size })} ${$$props.class}`}
    >
      <div class="toast-heading">{toastHeading}</div>
      {#if redirectUrl}
        <a href={redirectUrl} class="view-more-button" on:click={onViewNowClick}>
          {VIEW_NOW}
        </a>
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  .container {
    display: flex;
    justify-content: center;
    z-index: var(--z-index-toast-message);
    position: relative;
  }

  .toast-container {
    margin-bottom: 25px;
    width: 80%;
    position: fixed;
    bottom: 0;
    padding: 0px 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    border-radius: 10px;
  }

  .toast-heading {
    color: var(--color-text);
    font-size: 14px;
    font-weight: var(--font-weight-semibold);
    text-transform: capitalize;
  }

  .view-more-button {
    display: flex;
    width: 84px;
    height: 30px;
    padding: 10px;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 30px;
    background: var(--color-card-background);
    color: var(--color-text-light);
    text-decoration: none;
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
  }

  // .success {
  //   background-color: green;
  // }

  // .error {
  //   background-color: red;
  // }

  // .warning {
  //   background-color: yellow;
  // }

  .us-election {
    background-color: #e1e1e1;
  }

  .info {
    background-color: var(--color-toast-info);
  }

  .small {
    height: 50px;
  }

  .medium {
    height: 75px;
  }

  .large {
    height: 100px;
  }
</style>
